import hashUtils from 'app-lib/hashUtils'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { Tooltip } from 'ui-framework'

interface ITokenTipProps {
  iTokenAddress: string
  iTokenExplorerUrl: string
  children: React.ReactNode
}

/**
 * Shows a tooltip with the iToken smart contract and link to block explorer
 */
function TokenTip({ iTokenAddress, iTokenExplorerUrl, children }: ITokenTipProps) {
  const [tipId] = React.useState(Math.random() + iTokenAddress)
  return (
    <>
      <Tooltip id={tipId} className="tooltip__info" place="top" effect="solid" delayHide={200}>
        <h4 className="h4--muted margin-0">iToken Contract</h4>
        {iTokenAddress ? (
          <ExternalLink className="link--discreet" href={iTokenExplorerUrl}>
            {hashUtils.shortHash(iTokenAddress, 6, 6)}
          </ExternalLink>
        ) : (
          '-'
        )}
      </Tooltip>
      <div data-tip data-for={tipId}>
        {children}
      </div>
    </>
  )
}

export default React.memo(TokenTip)
